import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import withStyles from '@material-ui/core/styles/withStyles';
import Auth from '../services/auth';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import FormHelperText from '@material-ui/core/FormHelperText';
import UserDataAccess from '../services/userDataAccess';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
//import ReactGA from 'react-ga';
/*import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ProgressIndicator from './ProgressIndicator';*/
const userDataAccess = new UserDataAccess();

const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing(3),
    }),
    logo: {
        maxWidth: '100%',
        margin: 'auto',
        maxHeight: '40px'
    },
    page: {
        backgroundImage: `url(${"images/login_bg.jpg"})`,
        backgroundSize: 'cover',
        minHeight: 'calc(100vh - 24px)',
    },
    center: {
        textAlign: 'center'
    },
    link: {
        textDecoration: 'none'
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    forgotLinkText: {
        marginTop: theme.spacing(1)
    }
});

function getSteps() {
    return ['Set User Name', 'Confirm Email', 'Set Password', 'Login'];
}


class UpgradeToModernAccount extends React.Component {


    constructor(props) {
        super(props);
        this.Auth = new Auth();

        this.state = {
            username: this.Auth.getUserLogin() || '',
            currentPassword: '',
            password: '',
            confirmPassword: '',
            //updateLogin: false,
            headline: 'UPGRADE TO MODERN ACCOUNT',
            hasError: false,
            confirmationSent: false,
            loginErrorMessage: 'Invalid username or password.',
            errorMessage: '',
            emailcode: '',
            newusername: '',
            activeStep: 0,
            confirmError: '',
            confirmIdentityError: '',
            sendingConfirmation: false,
            confirmingCode: false,
            setPass: false,
            setPassDialog: false,
            loggingIn: false,
            logginBtn: false,
            hasErrorCP: false,
            hasErrorP: false,
            hasErrorConP: false,
            hasErrorSavingUser: false,
            //isSSOElegible: false,
            //ssoSelected: false,
            //UserAccountInFacility: false,
            //schema: '',
            //isDictator: false,
            //upgradeConfirmation: true,
            //closeUpgrade: true,
            //upgrade: false,
            user: {
                Id: 0,
                Account: "",
                AccountCreatedBy: "",
                Accounts: [],
                Active: true,
                SSOIdentity: "",
                Company: "",
                Dictators: [],
                EMail: "",
                FirstName: "",
                IsDeleted: false,
                IsDocumentWatermarked: false,
                IsVerified: true,
                LastName: "",
                Location: "",
                Maint: "",
                ModifyingUser: "",
                Password: "",
                Phone: "",
                Roles: ["Editor", "Signer"],
                SecArchive: false,
                SecCoding: 0,
                SecMarkRead: false,
                SecSave: false,
                SecSign: false,
                UserId: ""
            },
        };
    }

    handleNext = () => {
        const { activeStep } = this.state;

        this.setState({
            activeStep: activeStep + 1,
        });
    };


    isStepOptional = step => {
        return step === 1;
    };

    submit = (event) => {
        event.preventDefault();
        this.login();
    };

    confirmEmailCode = (event) => {
        event.preventDefault();
        this.onConfirmEmailCode();

    };

    sendVerificationCode = (event) => {

        event.preventDefault();
        this.onSendVerificationCode();

    }

    onConfirmEmailCode = () => {

        var code = this.state.emailcode;
        var self = this;
        var request = { EmailCode: code };
        self.setState({ confirmingCode: true });
        userDataAccess.confirmEmailCode(request).then(function (rs) {
            if (rs) {
                self.setState({ confirmationSent: false, setPassDialog: true, confirmIdentity: '', confirmingCode: false });
                self.handleNext();
            }
            else {
                self.setState({ confirmIdentityError: 'Invalid Email Code', confirmingCode: false })
            }
        });
    }

    onSendVerificationCode = () => {

        var usere = this.state.newusername;
        var self = this;
        var request = { Email: usere };

        self.setState({ sendingConfirmation: true })
        userDataAccess.SendVerificationCode(request).then(function (rs) {
            self.setState({ confirmationSent: true, confirmError: '', sendingConfirmation: false });
            self.handleNext();
        }).catch(error => {

            self.setState({ sendingConfirmation: false });
            if (error.response.status === 409) {
                if (error.response.data && error.response.data.Result) {
                    self.setState({ confirmError: error.response.data.Result.Errors.join() });
                } else if (error.response.data && error.response.data.Errors) {
                    self.setState({ confirmError: error.response.data.Errors.join() });
                }
                else {
                    self.setState({ confirmError: 'Unexpected Error Saving User' });
                }
            } else {
                self.setState({ confirmError: 'Unexpected Error Saving User' });
            }
        });
    }

    handleChange = field => event => {

        const { target: { value } } = event;
        this.setState({ [field]: value });
    }

    handleChangePass = field => event => {

        const { target: { value } } = event;
        this.setState({ [field]: value });

        this.validateInput(event);
    }

    validateInput = e => {

        let self = this;
        let { name, value } = e.target;
        let message;
        let error = false;

        switch (name) {
            case "txtCurrentPass":
                message = ""
                if (!value) {
                    message = "Please enter the Current Password.";
                    error = true;
                } else {
                    self.setState({ currentPassword: value })
                }
                self.setState({ hasErrorCP: error, errorMessage: message });
                break;

            case "txtPassword":
                message = ""
                if (!value) {
                    message = "Please enter Password.";
                    error = true;
                } else if (self.state.confirmPassword && value !== self.state.confirmPassword) {
                    message = "Password and Confirm Password does not match.";
                    error = true;
                }

                self.setState({ hasErrorP: error, errorMessage: message });
                break;

            case "confirmPass":
                message = ""
                if (!value) {
                    message = "Please enter Confirm Password.";
                    error = true;
                } else if (self.state.password && value !== self.state.password) {
                    message = "Password and Confirm Password does not match.";
                    error = true;
                }

                self.setState({ hasErrorConP: error, errorMessage: message });
                break;

            default:
                break;
        }

        return error;
    }

    settingPass = (event) => {

        event.preventDefault();
        if (!this.validateInput(event)) {
            this.onSettingPass();
        }
    }

    onSettingPass = () => {
        var self = this;
        self.setState({ setPass: true });
        this.Auth.login(this.state.username, this.state.currentPassword)
            .then(function (response) {

                userDataAccess.getDictatorInfo(self.Auth.getUserId(), self.Auth.getActiveAccount())
                    .then(function (info) {


                        let user = self.state.user;
                        let dictatorIn = self.Auth.getUserId().split("-");

                        user["Account"] = info.data[0].Account;
                        user["AccountCreatedBy"] = self.Auth.getUserId();
                        user["EMail"] = self.state.newusername;
                        user["FirstName"] = info.data[0].FirstName;
                        user["LastName"] = info.data[0].LastName;
                        user["Location"] = info.data[0].Location;
                        user["Phone"] = info.data[0].Phone;
                        user["UserId"] = self.state.newusername;
                        user["Dictators"].push({
                            Account: info.data[0].Account,
                            DictatorId: dictatorIn[1],
                            Physician: self.Auth.getUserName(),
                            Shard: "snotes"
                        });
                        user["Accounts"].push(info.data[0].Account);
                        user["Company"] = "Physician"

                        userDataAccess.upgradeDictatorUser(user)
                            .then(function (infoSave) {

                                
                                var resetPassword = {
                                    Account: infoSave.Account,
                                    Luid: infoSave.Id,
                                    Email: infoSave.EMail,
                                    Password: self.state.password,
                                    ConfirmPassword: self.state.confirmPassword,
                                    EmailCode: infoSave.EmailCode,
                                }
                                userDataAccess.resetPassword(resetPassword).then(function (result) {
                                    if (result) {
                                        self.setState({ setPass: false, loggingIn: true, setPassDialog: false });
                                        self.handleNext();
                                    }
                                }).catch(error => {
                                    if (error.response.status === 409) {
                                        if (error.response.data && error.response.data.Result) {
                                            self.setState({ passwordErrors: error.response.data.Result.Errors });
                                        } else if (error.response.data && error.response.data.Errors) {
                                            self.setState({ hasErrorSavingUser: true, errorMessage: 'Unexpected Error Saving User' })
                                        }
                                        else {
                                            self.setState({ hasErrorSavingUser: true, errorMessage: 'Unexpected Error Saving User' })
                                        }
                                    } else {
                                        self.setState({ hasErrorSavingUser: true, errorMessage: 'Unexpected Error Saving User' })
                                    }
                                });
                            }).catch(error => {
                                sessionStorage.clear();
                                if (error.response.status === 409) {
                                    if (error.response.data && error.response.data.Result) {
                                        self.setState({ hasErrorSavingUser: true, errorMessage: error.response.data.Result.Errors })
                                    }
                                    else if (error.response.data && error.response.data.Errors) {
                                        self.setState({ hasErrorSavingUser: true, errorMessage: `Unexpected Error Saving User: ${error.response.data.Errors.join()}` })
                                    }
                                    else {
                                        self.setState({ hasErrorSavingUser: true, errorMessage: 'Unexpected Error Saving User' })
                                    }
                                } else {
                                    self.setState({ hasErrorSavingUser: true, errorMessage: 'Unexpected Error Saving User' })
                                }
                            });
                    })
                    .catch(error => {
                        sessionStorage.clear();
                        self.setState({ setPass: false });
                        self.setState({ hasErrorSavingUser: true, errorMessage: 'Unexpected Error Saving User' });
                    });
            }).catch(error => {
                sessionStorage.clear();
                self.setState({ setPass: false });
                self.setState({ hasErrorSavingUser: true, errorMessage: 'Unexpected Error Saving User' });
            });
    }

    Login = (event) => {
        event.preventDefault();
        this.onLogin();
    };

    handleClose = () => {
        var history = this.props.history;
        var self = this;
        let path = self.props.location.state !== undefined ? self.props.location.state.from.pathname || '/' : '/';
        history.replace(path);
    };

    onLogin = () => {
        let self = this;
        self.setState({ logginBtn: true });

        self.Auth.login(self.state.user.UserId, self.state.password)
            .then(function (response) {
                userDataAccess.SetUpgradedValue(self.state.username, self.Auth.getHomeAccount())
                    .then(function (res) {
                        self.setState({ loggingIn: false });
                        self.Auth.setSSOIdentity("");
                        self.handleClose();
                    })
                    .catch(error => {
                        sessionStorage.clear();
                        self.setState({ hasError: true, errorMessage: `Unexpected Error Getting Upgraded Value` });
                    });
            }).catch(error => {
                sessionStorage.clear();
                self.setState({ logginBtn: false, hasError: true, errorMessage: `Unexpected Error Login` });
            });
    }

    render() {
        const { classes } = this.props;
        const steps = getSteps();
        const { activeStep, sendingConfirmation, logginBtn, confirmingCode, setPass } = this.state;

        return (<div className={classes.page}>
            <Grid container spacing={6} justify="center">
                <Grid item xs={12} sm={6} md={4}>
                    <Paper className={classes.root} elevation={4}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Grid container spacing={3} justify="center">
                                    <Grid item>
                                        <img className={classes.logo} src='/images/SNChart.jpg' alt='SNChart' />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={3} justify="center">
                                    <Grid item>
                                        <Typography variant="h5">
                                            {this.state.headline}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Stepper activeStep={activeStep}>
                                    {steps.map((label) => {
                                        const props = {};
                                        const labelProps = {};
                                        return (
                                            <Step key={label} {...props}>
                                                <StepLabel {...labelProps}>{label}</StepLabel>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </Grid>
                            {!this.state.confirmationSent && !this.state.setPassDialog && !this.state.loggingIn && <Grid container>
                                <Grid item xs={12}>
                                    <Typography>
                                        For your added security, an email address is required for your user name.  Please confirm your email address.
                                          <span style={{ color: 'red' }}>  This will become your new SNChart user name.</span>
                                        <br /><br />
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <form id="confirmUserName" onSubmit={this.sendVerificationCode}>
                                        <TextField fullWidth
                                            name="newusername"
                                            id="newusername"
                                            label="Email"
                                            onChange={this.handleChange('newusername')}
                                            error={this.state.confirmError.length > 0}
                                            value={this.state.newusername}
                                            type="email"
                                            required
                                        />
                                        {this.state.confirmError.length > 0 && <FormHelperText id="name-error-text" error>
                                            {this.state.confirmError}
                                        </FormHelperText>}
                                    </form>
                                    <br /><br />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={6} justify="center">
                                        <Grid item>
                                            <br />
                                            <div className={classes.wrapper}>
                                                <Button disabled={sendingConfirmation} type="submit" form="confirmUserName" onClick={this.sendVerificationCode} variant="contained" color="primary">Send Verification Code</Button>
                                                {sendingConfirmation && <CircularProgress size={24} className={classes.buttonProgress} />}
                                            </div>
                                            <br /> <br />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>}
                            {this.state.confirmationSent && <Grid container>
                                <Grid item xs={12}>
                                    <Typography>
                                        Enter confirmation code from the SNChart Email Confirmation you received.  If you do not receive this email, please check your spam or bulk email folder.
                                        <br /><br />
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <form id="confirmEmailCode" onSubmit={this.confirmEmailCode}>
                                        <TextField fullWidth
                                            name="email"
                                            id="email"
                                            label="User Name"
                                            error={this.state.hasError}
                                            required
                                            disabled
                                            value={this.state.newusername}
                                        /><br /><br />
                                        <TextField fullWidth
                                            name="emailCode"
                                            id="emailCode"
                                            label="Email Code"
                                            onChange={this.handleChange('emailcode')}
                                            error={this.state.confirmIdentityError.length > 0}
                                            required
                                            type="number"
                                            value={this.state.emailcode}
                                        />
                                        {this.state.confirmIdentityError.length > 0 && <FormHelperText id="name-error-text" error>
                                            {this.state.confirmIdentityError}
                                        </FormHelperText>}
                                    </form>
                                    <br /><br />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={6} justify="center">
                                        <Grid item>
                                            <br />
                                            <div className={classes.wrapper}>
                                                <Button type="submit" disabled={confirmingCode} form="confirmEmailCode" onClick={this.confirmEmailCode} variant="contained" color="primary">Confirm Email</Button>
                                                {confirmingCode && <CircularProgress size={24} className={classes.buttonProgress} />}
                                            </div>
                                            <br /> <br />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>}
                            {this.state.setPassDialog && <Grid container>
                                <Grid item xs={12}>
                                    <Typography>
                                        Create a new password for your account.
                                        <br /><br />
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <form id="setPassword" onSubmit={this.settingPass}>
                                        <TextField fullWidth
                                            name="txtCurrentPass"
                                            id="txtCurrentPass"
                                            type="password"
                                            required
                                            label="Current Password"
                                            onChange={this.handleChangePass('currentPassword')}
                                            onBlur={this.validateInput}
                                            value={this.state.currentPassword}
                                            error={this.state.hasError && this.state.hasErrorCP}
                                        />
                                        {this.state.hasErrorCP && <FormHelperText id="name-error-text" error>{this.state.errorMessage}</FormHelperText>}
                                        <br /><br />
                                        <TextField fullWidth
                                            name="txtPassword"
                                            id="txtPassword"
                                            type="password"
                                            required
                                            label="Password"
                                            onChange={this.handleChangePass('password')}
                                            onBlur={this.validateInput}
                                            value={this.state.password}
                                            error={this.state.hasError && this.state.hasErrorP}
                                        />
                                        {this.state.hasErrorP && <FormHelperText id="name-error-text" error>{this.state.errorMessage}</FormHelperText>}
                                        <br /><br />
                                        <TextField fullWidth
                                            name="confirmPass"
                                            id="confirmPass"
                                            type="password"
                                            required
                                            label="Confirm Password"
                                            onChange={this.handleChangePass('confirmPassword')}
                                            value={this.state.confirmPassword}
                                            onBlur={this.validateInput}
                                            error={this.state.hasError && this.state.hasErrorConP}
                                        />
                                        {this.state.hasErrorConP && <FormHelperText id="name-error-text" error>{this.state.errorMessage}</FormHelperText>}
                                        {this.state.hasErrorSavingUser && <FormHelperText id="name-error-text" error>{this.state.errorMessage}</FormHelperText>}
                                    </form>
                                    <br /><br />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={6} justify="center">
                                        <Grid item>
                                            <br />
                                            <div className={classes.wrapper}>
                                                <Button type="submit" disabled={setPass} form="setPassword" onClick={this.settingPass} variant="contained" color="primary">Set Password</Button>
                                                {setPass && <CircularProgress size={24} className={classes.buttonProgress} />}
                                            </div>
                                            <br /> <br />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>}
                            {this.state.loggingIn && <Grid container>
                                <Grid item xs={12}>
                                    <Typography>
                                        Please login to finish with the process.
                                        <br /><br />
                                    </Typography>
                                </Grid>
                                {this.state.hasError && <FormHelperText id="name-error-text" error>{this.state.errorMessage}</FormHelperText>}
                                <Grid item xs={12}>
                                    <form id="login" onSubmit={this.Login}>
                                        <Grid container spacing={6} justify="center">
                                            <Grid item>
                                                <br />
                                                <div className={classes.wrapper}>
                                                    <Button type="submit" disabled={logginBtn} form="login" onClick={this.Login} variant="contained" color="primary">Login</Button>
                                                    {logginBtn && <CircularProgress size={24} className={classes.buttonProgress} />}
                                                </div>
                                                <br /> <br />
                                            </Grid>
                                        </Grid>
                                        {this.state.hasError && <FormHelperText id="name-error-text" error>{this.state.errorMessage}</FormHelperText>}
                                    </form>
                                </Grid>
                            </Grid>}
                            {!this.state.loggingIn &&
                                <Grid item xs={12}>
                                    <Grid container justify="center">
                                        <Link to='/login' className={classes.forgotLinkText}>
                                            <Typography align="center" variant="body2" gutterBottom>
                                                Cancel
                                        </Typography>
                                        </Link>
                                    </Grid>
                                </Grid>}
                            <Grid item xs={12}>
                                <Grid container spacing={3} justify="center">
                                    <Grid item>
                                        <Typography align="center" variant="body2" gutterBottom>
                                            Contact support at
                                        </Typography>
                                        <a href='tel:8008660656' className={classes.link}>
                                            <Typography align="center" variant="body2" gutterBottom>
                                                (800) 866-0656
                                            </Typography>
                                        </a>
                                        <a href="mailto:acctmgrs@surgicalnotes.com?subject=SNChart Customer Request/Issue" className={classes.link}>
                                            <Typography align="center" variant="body2" gutterBottom>
                                                acctmgrs@surgicalnotes.com
                                            </Typography>
                                        </a>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={3} justify="center">
                                    <Grid item xs={12} className={classes.center}>
                                        <img className={classes.logo} src='/images/SNLogo.png' alt='Surgical Notes' />
                                    </Grid>
                                </Grid>
                            </Grid>                            
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </div>);
    }
}

export default withStyles(styles)(UpgradeToModernAccount);


// WEBPACK FOOTER //
// ./src/components/UpgradeToModernAccount.js